// services/mappers/role.js
export const setRole = (el = {}) => ({
  createdAt: el?.CreatedAt || null,
  updatedAt: el?.UpdatedAt || null,
  deletedAt: el?.DeletedAt || null,
  id: el?.ID || null,
  name: el?.name || null,
  admin_panel_access: el?.admin_panel_access || false,
  drone_edit_access: el?.drone_edit_access || false,
  pilot_mode_access: el?.pilot_mode_access || false,
  weapon_access: el?.weapon_access || false,
});
